import React from 'react';
import './modelFlowDiagram.css';
// import { FaArrowRight as Arrow } from 'react-icons/lib/fa';
import { FaQuestionCircle as QuestionCircle, FaArrowRight as Arrow } from 'react-icons/lib/fa';
import ReactTooltip from 'react-tooltip';
import { t } from 'i18next';

const modelFlowDiagram = ({ trainPct, numberOfDevices }) => {
  const testPct = 100 - trainPct;
  return (
    <div className="diagram-container">
      <div className="model-diagram">
        <div className="diagram-flow">
          <div><h6>Create Model</h6></div>
          <Arrow size="21" />
          <div className="diagram-box">
            <h6>
              {t('tensorAnalytics.modelsPage.trainModel')}
              <div className="training-tip">
                <QuestionCircle size="21"
                  className="question-circle"
                  data-for="training"
                  data-tip
                  onClick={(e) => { e.stopPropagation(); }}
                />
                <ReactTooltip id="training"
                  effect="solid"
                  type="light"
                  place="right"
                  className="tooltip"
                >
                  <span>
                    <p>
                      {t('tensorAnalytics.modelsPage.trainTooltip1')}
                      <strong>
                        {`${trainPct}% `}
                      </strong>
                      {t('tensorAnalytics.modelsPage.trainTooltip2')}
                      <strong>{` ${parseInt((trainPct / 100) * (numberOfDevices), 10)}`}</strong>
                      {t('tensorAnalytics.modelsPage.trainTooltip3', {
                        validationSplit: 'Training',
                      })}
                    </p>
                  </span>
                </ReactTooltip>
              </div>
              <p>
                {`(${trainPct}% ${t('tensorAnalytics.modelsPage.trainSplitSummary')})`}
              </p>
            </h6>
          </div>
          <Arrow size="21" />
          <div className="diagram-box">
            <h6>
              {t('tensorAnalytics.modelsPage.testModel')}
              <div className="testing-tip">
                <QuestionCircle size="21"
                  className="question-circle"
                  data-for="testing"
                  data-tip
                  onClick={(e) => { e.stopPropagation(); }}
                />
                <ReactTooltip id="testing"
                  effect="float"
                  type="light"
                  place="right"
                  className="tooltip"
                >
                  <span>
                    <p>
                      {t('tensorAnalytics.modelsPage.testTooltip1')}
                      <strong>
                        {`${testPct}% `}
                      </strong>
                      {t('tensorAnalytics.modelsPage.trainTooltip2')}
                      <strong>{` ${parseInt((testPct / 100) * (numberOfDevices), 10)} `}</strong>
                      {t('tensorAnalytics.modelsPage.trainTooltip3', {
                        validationSplit: 'Testing',
                      })}
                    </p>
                  </span>
                </ReactTooltip>
              </div>
              <p>
                {`(${100 - trainPct}% ${t('tensorAnalytics.modelsPage.trainSplitSummary')})`}
              </p>
            </h6>
          </div>
          <Arrow size="21" />
          <div>
            <h6>
              {t('tensorAnalytics.modelsPage.finalDiagramTitle')}
              <p>{t('tensorAnalytics.modelsPage.finalDiagramSummary')}</p>
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default modelFlowDiagram;
